import { render } from "./base-form-row.vue?vue&type=template&id=5b5df653&ts=true"
import script from "./base-form-row.vue?vue&type=script&lang=ts"
export * from "./base-form-row.vue?vue&type=script&lang=ts"

import "./base-form-row.vue?vue&type=style&index=0&id=5b5df653&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__